module.exports = __webpack_public_path__ + "img/Banking.d596b465.svg";